/* NIGHTGRID RACING — behaviour for NIGHTGRID sections only.
   Product variant/cart behaviour is handled by Dawn's product-info.js, product-form.js and media-gallery.js. */
document.addEventListener('DOMContentLoaded', () => {
  // Collection sort select (main-collection-nightgrid)
  document.querySelector('.nightgrid [data-sort]')?.addEventListener('change', (event) => {
    const url = new URL(location.href);
    url.searchParams.set('sort_by', event.target.value);
    location.href = url.toString();
  });

  // Reviews / other products horizontal carousel (product-reviews-nightgrid)
  const scrollTrack = (button, direction) => {
    button.closest('.reviews-row')?.querySelector('[data-carousel]')?.scrollBy({ left: 360 * direction, behavior: 'smooth' });
  };
  document.querySelectorAll('.nightgrid [data-carousel-prev]').forEach((button) => button.addEventListener('click', () => scrollTrack(button, -1)));
  document.querySelectorAll('.nightgrid [data-carousel-next]').forEach((button) => button.addEventListener('click', () => scrollTrack(button, 1)));
});
